import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet-async';

import faqMetaResolver from '../../state/resolvers/schema/faqs';

class FaqsMeta extends PureComponent {
  render() {
    const { faqs } = this.props;
    return <Helmet script={faqMetaResolver(faqs)} />;
  }
}

export default FaqsMeta;
